/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './id-service-access-management-schema-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './id-service-access-management-schema-types';
const defaultOptions = {} as const;
export type AvailableUserRolesQueryVariables = Exact<{
  filter?: Types.UserRoleFilter | null | undefined;
  orderBy?: Array<Types.UserRolesOrderBy> | Types.UserRolesOrderBy | null | undefined;
  after?: any;
}>;


export type AvailableUserRolesQuery = { filtered: { totalCount: number, nodes: Array<{ id: any, name: string, description: string | null, createdAt: any, updatedAt: any, userRoleTagAssignments: { nodes: Array<{ tag: string }> } }>, pageInfo: { hasNextPage: boolean, endCursor: any } } | null, nonFiltered: { totalCount: number } | null };

export type ActivePermissionsQueryVariables = Exact<{
  filter?: Types.ActivePermissionFilter | null | undefined;
}>;


export type ActivePermissionsQuery = { activePermissions: { nodes: Array<{ id: any, name: string | null, title: string | null, fromManagedService: boolean | null, serviceId: string | null }> } | null };


export const AvailableUserRolesDocument = gql`
    query AvailableUserRoles($filter: UserRoleFilter, $orderBy: [UserRolesOrderBy!], $after: Cursor) {
  filtered: userRoles(
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    nodes {
      id
      name
      description
      createdAt
      updatedAt
      userRoleTagAssignments {
        nodes {
          tag
        }
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
  nonFiltered: userRoles {
    totalCount
  }
}
    `;

/**
 * __useAvailableUserRolesQuery__
 *
 * To run a query within a React component, call `useAvailableUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableUserRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAvailableUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<AvailableUserRolesQuery, AvailableUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableUserRolesQuery, AvailableUserRolesQueryVariables>(AvailableUserRolesDocument, options);
      }
export function useAvailableUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableUserRolesQuery, AvailableUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableUserRolesQuery, AvailableUserRolesQueryVariables>(AvailableUserRolesDocument, options);
        }
export type AvailableUserRolesQueryHookResult = ReturnType<typeof useAvailableUserRolesQuery>;
export type AvailableUserRolesLazyQueryHookResult = ReturnType<typeof useAvailableUserRolesLazyQuery>;
export type AvailableUserRolesQueryResult = Apollo.QueryResult<AvailableUserRolesQuery, AvailableUserRolesQueryVariables>;
export const ActivePermissionsDocument = gql`
    query ActivePermissions($filter: ActivePermissionFilter) {
  activePermissions(filter: $filter, orderBy: TITLE_ASC) {
    nodes {
      id
      name
      title
      fromManagedService
      serviceId
    }
  }
}
    `;

/**
 * __useActivePermissionsQuery__
 *
 * To run a query within a React component, call `useActivePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivePermissionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useActivePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<ActivePermissionsQuery, ActivePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivePermissionsQuery, ActivePermissionsQueryVariables>(ActivePermissionsDocument, options);
      }
export function useActivePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivePermissionsQuery, ActivePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivePermissionsQuery, ActivePermissionsQueryVariables>(ActivePermissionsDocument, options);
        }
export type ActivePermissionsQueryHookResult = ReturnType<typeof useActivePermissionsQuery>;
export type ActivePermissionsLazyQueryHookResult = ReturnType<typeof useActivePermissionsLazyQuery>;
export type ActivePermissionsQueryResult = Apollo.QueryResult<ActivePermissionsQuery, ActivePermissionsQueryVariables>;